import { AsyncPipe, DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DateTime } from 'luxon';
import { combineLatest, map, Observable, shareReplay, tap } from 'rxjs';
import { LicenseType } from '../../models/public-payment-info';
import { PaymentService } from '../../services/payment.service';
import { UserProfileService } from '../../services/user-profile.service';
import { EndOfFreeTrialDialogUserComponent } from './end-of-free-trial-dialog-user/end-of-free-trial-dialog-user.component';

interface HeaderInformation {
    isRawFreeLicense: boolean;
    isOwner: boolean;
    testDaysLeft: number;
}

@Component({
    selector: 'app-test-phase-info',
    templateUrl: './test-phase-info.component.html',
    imports: [MatIconModule, DecimalPipe, AsyncPipe],
})
export class TestPhaseInfoComponent {
    private readonly userProfileService = inject(UserProfileService);
    private readonly paymentService = inject(PaymentService);
    private readonly dialog = inject(MatDialog);

    private dialogOpened = false;
    protected headerInformation$: Observable<HeaderInformation>;

    constructor() {
        this.headerInformation$ = combineLatest([
            this.userProfileService.getOwnUserProfile(),
            this.paymentService.getTenantPublicPaymentInformation(),
        ]).pipe(
            takeUntilDestroyed(),
            map(([userProfile, paymentInfo]) => ({
                isOwner: paymentInfo.owner === userProfile.uid,
                isRawFreeLicense: paymentInfo.license === LicenseType.FREE,
                testDaysLeft: paymentInfo.endOfFreeTrial
                    ? DateTime.fromISO(paymentInfo.endOfFreeTrial).diffNow(['days']).days
                    : 0,
            })),
            tap((headerInformation) => {
                if (
                    !this.dialogOpened &&
                    headerInformation.isRawFreeLicense &&
                    headerInformation.testDaysLeft < 0 &&
                    !headerInformation.isOwner
                ) {
                    this.dialogOpened = true;
                    this.dialog.open(EndOfFreeTrialDialogUserComponent, {
                        disableClose: true,
                        backdropClass: ['backdrop-blur'],
                        hasBackdrop: true,
                    });
                }
            }),
            shareReplay({ bufferSize: 1, refCount: true }),
        );
    }
}
